import DataTable from '../../components/DataTable'
import SectionCard from '../../components/SectionCard'
import { formatDate } from '../../utils/inventoryFormatters'
import { formatInventoryQuantity } from '../../utils/inventoryUnits'
import {
  resolveItemId,
  resolveItemUnit,
  resolveStockQuantity,
  resolveWarehouseLabel
} from '../../utils/inventoryResolvers'

const resolveStockBaseUnit = (row, itemOptions) => {
  const directUnit = resolveItemUnit(row, '')
  if (directUnit) return directUnit

  const itemId = resolveItemId(row)
  if (itemId > 0) {
    const optionById = itemOptions.find(option => Number(option.id) === itemId)
    if (optionById?.unit) return optionById.unit
  }

  const rowSku = String(row?.sku ?? row?.item_sku ?? '').trim().toUpperCase()
  if (rowSku) {
    const optionBySku = itemOptions.find(
      option => String(option.sku || '').trim().toUpperCase() === rowSku
    )
    if (optionBySku?.unit) return optionBySku.unit
  }

  return ''
}

const StockSection = ({ data, state }) => (
  <SectionCard title='Inventario actualizado' description='Vista materializada de existencias actuales en la unidad base del item.'>
    <div className='mb-3'>
      <input
        type='text'
        value={state.stockSearch}
        onChange={event => state.setStockSearch(event.target.value)}
        className='w-full md:w-[320px] border border-gray-300 rounded-lg px-3 py-2 text-sm'
        placeholder='Buscar por SKU o item'
      />
    </div>

    <DataTable
      columns={['SKU', 'Item', 'Bodega', 'Cantidad', 'Actualizado']}
      rows={data.stock}
      loading={data.stockQuery.isLoading || data.isLoadingAny}
      emptyText='Sin stock para mostrar'
      renderRow={row => (
        <>
          <td className='px-4 py-2'>{row?.sku ?? row?.item_sku ?? '-'}</td>
          <td className='px-4 py-2'>{row?.itemName ?? row?.item_name ?? row?.name ?? row?.nombre ?? '-'}</td>
          <td className='px-4 py-2'>{resolveWarehouseLabel(row)}</td>
          <td className='px-4 py-2'>
            {formatInventoryQuantity(
              resolveStockQuantity(row),
              resolveStockBaseUnit(row, data.itemOptions)
            )}
          </td>
          <td className='px-4 py-2'>{formatDate(row?.updatedAt ?? row?.updated_at ?? row?.fecha)}</td>
        </>
      )}
    />
  </SectionCard>
)

export default StockSection
